import clsx from "clsx";
import { SectionTitle, TextBadge } from "components/atoms/Text";
import { affiliateFeatureList } from "data";
import AffiliateCard from "components/organism/Cards/AffiliateCard";

const Features = () => {
    return (
        <section className="features w-full max-w-[1440px] mx-auto phone:pt-12 phone:pb-12 tablet:py-16 pt-[88px] pb-[112px]">
            <section className={clsx(
                "w-full mx-auto max-w-full tablet:max-w-[526px] desktop:max-w-[603px] bg-neutral-10 text-center",
                "px-6 md:px-0"
            )}>
                <TextBadge>Features</TextBadge>
                <SectionTitle classNames="!pb-0 phone:leading-[48px] tablet:!text-[40px] tablet:leading-[54px]">Why Should You Join Affiliate Program?</SectionTitle>
            </section>
            <section className={clsx(
                "grid grid-cols-1 md:grid-cols-3 tablet:gap-8 phone:gap-10 gap-8",
                "pt-[72px] tablet:pt-16 phone:pt-12 px-6 phone:px-0 tablet:px-8 desktop:px-[120px]"
            )}>
                {affiliateFeatureList.map((item) => (
                    <AffiliateCard key={item.id} icons={item.icons} title={item.title} description={item.description} />
                ))}
            </section>
        </section>
    );
};

export default Features;